/**
 * Claves y etiquetas de permisos por tablero (formato true/false en tabla de permisos).
 * moveBetweenBoards no se incluye: equivale a sendTasks.
 */
export const BOARD_PERMISSION_KEYS = [
  'moveBetweenStates',
  'createTasks',
  'editTasks',
  'deleteTasks',
  'reassignTasks',
  'addComments',
  'editDeleteComments',
  'manageLabels',
  'manageBoard',
  'viewActivityHistory',
  'uploadAttachments',
  'managePermissions'
];

export const BOARD_PERMISSION_LABELS = {
  moveBetweenStates: 'Puede mover tareas entre estados (por hacer, en progreso, completado, eliminado)',
  createTasks: 'Puede crear tareas',
  editTasks: 'Puede editar tareas',
  deleteTasks: 'Puede eliminar tareas',
  reassignTasks: 'Puede reasignar responsables',
  addComments: 'Puede añadir comentarios',
  editDeleteComments: 'Puede editar y eliminar comentarios',
  manageLabels: 'Puede gestionar etiquetas del tablero',
  manageBoard: 'Puede gestionar el tablero (editar/eliminar)',
  viewActivityHistory: 'Puede ver historial de actividad',
  uploadAttachments: 'Puede subir archivos adjuntos',
  managePermissions: 'Puede gestionar permisos del tablero'
};

/** Valores por defecto para todos los permisos de tablero (false) */
export function getDefaultBoardPermissions() {
  return BOARD_PERMISSION_KEYS.reduce((acc, key) => {
    acc[key] = false;
    return acc;
  }, {});
}

/** Etiquetas para restricciones del tablero (columna Permisos del proyecto). Si está activo, solo usuarios con ese permiso pueden hacer la acción. */
export const BOARD_RESTRICTION_LABELS = {
  moveBetweenStates: 'Requerir permiso para mover tareas entre estados',
  createTasks: 'Requerir permiso para crear tareas',
  editTasks: 'Requerir permiso para editar tareas',
  deleteTasks: 'Requerir permiso para eliminar tareas',
  reassignTasks: 'Requerir permiso para reasignar responsables',
  addComments: 'Requerir permiso para añadir comentarios',
  editDeleteComments: 'Requerir permiso para editar/eliminar comentarios',
  manageLabels: 'Requerir permiso para gestionar etiquetas',
  manageBoard: 'Requerir permiso para gestionar el tablero',
  viewActivityHistory: 'Requerir permiso para ver historial de actividad',
  uploadAttachments: 'Requerir permiso para subir adjuntos',
  managePermissions: 'Requerir permiso para gestionar permisos del tablero'
};
